import * as React from 'react';
const Movement = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 24"
		fill="none"
		{...props}
	>
		<path
			fill="#fff"
			d="m17 15-1.057 1.058 2.685 2.692H6.5a3 3 0 0 1 0-6h9a4.5 4.5 0 1 0 0-9H3.373l2.684-2.692L5 0 .5 4.5 5 9l1.058-1.058L3.373 5.25H15.5a3 3 0 0 1 0 6h-9a4.5 4.5 0 1 0 0 9h12.128l-2.685 2.692L17 24l4.5-4.5L17 15Z"
		/>
	</svg>
);
export default Movement;
